import { createContext } from 'react';

import { useVisibilityOptions } from 'hooks';
import { LocalStorageKey } from 'api/localStorage/constants';
import { DEFAULT_COLUMN_VISIBILITY } from 'constants/table';

import { IVisibilityOptionsContext } from './models';

export const TableViewContext = createContext<IVisibilityOptionsContext>({});

interface IProps {
  children: React.ReactNode;
}

export const TableViewProvider = ({ children }: IProps) => {
  const { visibleFields, handleVisibleFieldsChange } = useVisibilityOptions(
    LocalStorageKey.PRODUCT_LISTING_COLUMNS,
    DEFAULT_COLUMN_VISIBILITY
  );
  return (
    <TableViewContext.Provider
      value={{
        visibleFields,
        handleVisibleFieldsChange,
      }}
    >
      {children}
    </TableViewContext.Provider>
  );
};
